import { reset, change } from "redux-form";
import { getSearchResults, loadingSearchResults } from "./getSearchResults";
import GetSearchResults from "../../src/components/SearchListing/SearchResults/GetSearchResults.graphql"
import {
  SEARCH_LISTING_START,
  SEARCH_LISTING_SUCCESS,
  SEARCH_LISTING_ERROR,
} from "../constants";

export function searchListing({
  personCapacity,
  dates,
  currentPage,
  location,
  totalPrice
}) {
  return async (dispatch, _, { client }) => {
    dispatch({ type: SEARCH_LISTING_START });
    dispatch(loadingSearchResults());
    dispatch(reset("SearchForm"));
    try {
      const { data } = await client.query({
        query: GetSearchResults,
        variables: {
          personCapacity: Number(personCapacity),
          dates,
          currentPage,
          location
        },
        fetchPolicy: "network-only",
      });
      if (data?.SearchListing) {
        dispatch({ type: SEARCH_LISTING_SUCCESS });
        await Promise.all([
          dispatch(change("SearchForm", "personCapacity", personCapacity)),
          dispatch(change("SearchForm", "dates", dates)),
          dispatch(change("SearchForm", "location", location)),
          dispatch(change("SearchForm", "currentPage", currentPage)),
          dispatch(change("SearchForm", "initialLoad", true)),
        ]);
        dispatch(getSearchResults(data?.SearchListing));
      }
    } catch (error) {
      dispatch({
        type: SEARCH_LISTING_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }

    return true;
  };
}
